import React from 'react';
import LegalPage from './LegalPage';

export default function CGV() {
  return (
    <LegalPage
      title="Conditions Générales de Vente"
      subtitle="CGV — Abonnements TripNova SaaS"
      lastUpdate="31 mai 2026"
      testid="page-cgv"
    >
      <h2>1. Objet et champ d'application</h2>
      <p>
        Les présentes Conditions Générales de Vente (ci-après « <strong>CGV</strong> ») s'appliquent
        à tous les abonnements souscrits à la plateforme <strong>TripNova SaaS</strong> par les
        agences de voyages clientes (ci-après l'« <strong>Agence</strong> »).
      </p>

      <h2>2. Offre commerciale</h2>
      <p>
        TripNova propose des formules d'abonnement adaptées aux besoins des agences de voyages :
      </p>
      <ul>
        <li><strong>Phase bêta (en cours)</strong> : accès gratuit pour les 5 agences pilotes invitées.
            Aucune facturation pendant la durée de la bêta.</li>
        <li><strong>Plans payants (V1)</strong> : Starter, Pro, Enterprise — détails sur la page Tarifs.</li>
      </ul>
      <p>
        Les tarifs sont indiqués en <strong>Dinars Algériens (DZD)</strong> hors taxes.
        Les taxes éventuelles sont appliquées en sus selon la législation en vigueur.
      </p>

      <h2>3. Modalités de paiement</h2>
      <p>
        Pendant la phase de lancement, les paiements s'effectuent exclusivement par{' '}
        <strong>virement bancaire</strong> vers le compte communiqué dans l'espace d'administration
        de l'Agence (RIB consultable et téléchargeable au format PDF).
      </p>
      <p>
        La procédure est la suivante :
      </p>
      <ol>
        <li>L'Agence effectue le virement du montant correspondant à son plan choisi.</li>
        <li>L'Agence envoie une preuve de virement à <a href="mailto:aatvgeste@gmail.com">aatvgeste@gmail.com</a>.</li>
        <li>Sous 48 heures ouvrées, le compte est activé/renouvelé par l'équipe TripNova.</li>
      </ol>
      <p>
        L'accès au Service est conditionné à la réception effective des fonds.
      </p>

      <h2>4. Durée et reconduction</h2>
      <p>
        Les abonnements sont conclus pour une durée mensuelle ou annuelle selon le choix de l'Agence.
        Ils ne sont <strong>pas reconduits automatiquement</strong> : l'Agence doit effectuer un
        nouveau virement à chaque échéance pour maintenir son accès.
      </p>
      <p>
        Un email de rappel est envoyé 7 jours avant la fin de l'abonnement.
      </p>

      <h2>5. Période d'essai</h2>
      <p>
        Toute nouvelle agence (hors bêta) bénéficie d'une <strong>période d'essai gratuite de 5 jours</strong>,
        sans engagement et sans demande de moyen de paiement.
      </p>

      <h2>6. Droit de rétractation</h2>
      <p>
        En vertu de la nature des services numériques fournis (accès immédiat dès activation),
        et conformément aux règles applicables aux contrats B2B, <strong>aucun droit de rétractation
        ne s'applique</strong> après activation du compte. Les sommes versées ne sont pas remboursables,
        sauf cas d'indisponibilité grave et prolongée du Service imputable à l'Éditeur.
      </p>

      <h2>7. Modifications tarifaires</h2>
      <p>
        L'Éditeur se réserve le droit de modifier ses tarifs. Toute modification fera l'objet
        d'une information préalable de <strong>30 jours</strong> minimum aux Agences abonnées.
        L'Agence peut alors choisir de ne pas renouveler son abonnement aux nouvelles conditions.
      </p>

      <h2>8. Résiliation</h2>
      <p>
        L'Agence peut résilier son abonnement à tout moment en cessant simplement de le renouveler.
        Aucun engagement de durée n'est imposé au-delà de la période payée.
      </p>
      <p>
        En cas de résiliation pour faute (violation des CGU, fraude, défaut de paiement répété),
        l'Éditeur se réserve le droit de suspendre immédiatement l'accès au Service, sans
        remboursement des sommes déjà versées.
      </p>

      <h2>9. Suspension pour défaut de paiement</h2>
      <p>
        À défaut de renouvellement à l'échéance :
      </p>
      <ul>
        <li>L'accès au Service est suspendu (lecture seule) dans les 24 heures suivant la fin de la période.</li>
        <li>Les Données sont conservées 30 jours, période pendant laquelle l'Agence peut régulariser son paiement ou exporter ses données.</li>
        <li>Au-delà de 30 jours sans régularisation, les Données peuvent être archivées ou supprimées définitivement.</li>
      </ul>

      <h2>10. Réversibilité et export des données</h2>
      <p>
        À tout moment, l'Agence peut exporter ses données via les fonctionnalités d'export Excel/PDF
        intégrées à la Plateforme. En cas de résiliation, l'Éditeur fournit sur demande un export
        complet des données structurées dans un délai raisonnable.
      </p>

      <h2>11. Responsabilité de l'Éditeur</h2>
      <p>
        La responsabilité de l'Éditeur est limitée au montant total versé par l'Agence sur les
        12 derniers mois d'abonnement. Sont expressément exclus les dommages indirects (perte de
        chiffre d'affaires, perte de clientèle, atteinte à l'image).
      </p>

      <h2>12. Loi applicable</h2>
      <p>
        Les présentes CGV sont soumises au droit algérien. Tout litige relatif à leur application
        sera porté devant les tribunaux compétents d'Alger après tentative de résolution amiable.
      </p>

      <h2>13. Contact</h2>
      <p>
        Pour toute question commerciale ou demande de devis personnalisé :{' '}
        <a href="mailto:aatvgeste@gmail.com">aatvgeste@gmail.com</a>
      </p>
    </LegalPage>
  );
}
